"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../..");
var results_hub_1 = require("../../results-hub");
var logger_1 = require("../../logger");
var config_1 = require("../../config");
exports.getUrl = function (url) {
    return encodeURI(config_1.baseUrl() + "/" + url);
};
exports.parseErrorMessage = function (e) {
    if (typeof e === 'object' && e.error) {
        var cleaner = JSON.parse(e.error);
        return (cleaner.message) ? cleaner.message : e;
    }
    else {
        return "" + e;
    }
};
exports.checkForErrorResponse = function (args, url, response, errorCreator, reject, st) {
    if (st === void 0) { st = __1.store; }
    // check if reject is there (this might be outside of a promise lifecycle)
    var rejectWithError = function (error) {
        var which = reject || st.dispatch;
        which(errorCreator(args, url, exports.parseErrorMessage(error)));
    };
    try {
        var _a = JSON.parse(response), result = _a.result, error = _a.error;
        if (error) {
            rejectWithError(error);
        }
        else if (result) {
            return JSON.parse(result);
        }
        else {
            rejectWithError(error);
        }
    }
    catch (error) {
        rejectWithError(error);
    }
};
exports.callbackMap = {};
exports.pollForData = function (args, url, pollingInterval, actionCreator, succesfulResponse, errorCreator, st) {
    if (st === void 0) { st = __1.store; }
    return new Promise(function (resolve, reject) {
        var fullUrl = exports.getUrl(url);
        logger_1.Log.info("Polling for data at '" + fullUrl + "' " +
            ("every " + pollingInterval + "ms"));
        var callback = function (response) {
            var json = exports.checkForErrorResponse(args, url, response, errorCreator, resolve);
            if (resolve && json) {
                st.dispatch(succesfulResponse);
                resolve = undefined;
            }
            logger_1.Log.info("Response for url '" + fullUrl + "' recieved: " +
                ("" + json));
            // we need to check if we are getting spurious updates
            if (json) {
                st.dispatch(actionCreator(json, args));
            }
            // publish errors on the store!
        };
        if (exports.callbackMap[url]) {
            var message = "Duplicate subscription detected on " + url + ", " +
                "only one subscription can exist per runtime.  That includes " +
                "parameters, so please check your args.";
            logger_1.Log.error(message);
            if (!config_1.suppressSubscriptionErrors())
                reject(errorCreator(args, url, message));
        }
        else {
            exports.callbackMap[url] = callback;
        }
        config_1.subscribe(fullUrl, callback, pollingInterval).catch(function (reason) {
            logger_1.Log.error('Subscription problem: ', reason);
            reject(errorCreator(args, url, reason));
        });
    });
};
exports.stopPolling = function (args, url, succesfulResponse, errorCreator) {
    return new Promise(function (resolve, reject) {
        try {
            var fullUrl = exports.getUrl(url);
            var callback = exports.callbackMap[url];
            if (!callback) {
                var message = "No subscription found on url: " + url + ". " +
                    "Parameters count, so make sure to pass in the original " +
                    "args!";
                logger_1.Log.error(message);
                reject(errorCreator(args, url, message));
            }
            // we get spurious extra messages while it's tryin to unmount
            var didIt = results_hub_1.ResultsHubClient.unsubscribe(fullUrl, callback);
            if (resolve && didIt) {
                resolve(succesfulResponse);
                resolve = undefined;
                exports.callbackMap[url] = undefined;
            }
        }
        catch (error) {
            reject(errorCreator(args, url, error));
        }
    });
};
exports.waitForData = function (args, url, actionCreator, errorCreator) {
    return new Promise(function (resolve, reject) {
        var fullUrl = exports.getUrl(url);
        logger_1.Log.info("Requesting data from '" + fullUrl + "'");
        try {
            var callback_1 = function (response) {
                try {
                    var json = exports.checkForErrorResponse(args, url, response, errorCreator, reject);
                    logger_1.Log.info("Response for url '" + fullUrl + "' recieved: " +
                        ("" + json));
                    if (resolve && json) {
                        results_hub_1.ResultsHubClient.unsubscribe(fullUrl, callback_1);
                        resolve(actionCreator(json, args));
                        resolve = undefined;
                    }
                }
                catch (error) {
                    reject(errorCreator(args, url, error));
                }
            };
            config_1.subscribe(fullUrl, callback_1);
        }
        catch (error) {
            reject(errorCreator(args, url, error));
        }
    });
};
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/epics/util/index.js
 ** module id = 205
 ** module chunks = 0
 **/